<template lang='slm'>
.bz-editor.row.bg-faded
  .col-12 v-if='bzData.title'
    h3 {{ localized('title') }}
  .components
    component :is="tagByModel(child[0])" v-for="child in children" :id="child[1]" :key="compoundKey(...child)"
</template>
<script>
import BzTreeItem from '@/components/mixins/bz-tree-item'
import BzParagraph from '@/components/bz-tree/BzParagraph'
import BzText from '@/components/bz-tree/BzText'
import FontAwesomeIcon from '@/fontawesome'

export default {
  data () {
    return { modelTag: 'bz-article' }
  },
  name: 'BzEditor',
  mixins: [ BzTreeItem ],
  components: { BzParagraph, BzText, FontAwesomeIcon }
}
</script>
<style scoped lang='scss'>
  @import 'node_modules/bootstrap/scss/bootstrap-reboot';
  .bz-editor {
    background: $light;
  }
</style>



// WEBPACK FOOTER //
// src/components/BzEditor.vue